import React, { useEffect, useState } from 'react'
import "../../CssFiles/helloTrade.css"
import Modal from 'react-bootstrap/Modal';

import rupeeIcon from '../../Images/helloTradeImages/RupeeIcon.png'
import logo from '../../Images/helloTradeImages/HelloTradeLogo.png'

export default function HeaderComponent() {
  const [optionsDate,setOptionsDate] = useState([]);
  const [optionsTime,setOptionsTime] = useState([]);
  const [guidanceBox,setGuidanceBox] = useState(false);

  const handleGoClick = ()=>{
    window.location.href = 'https://indiamart.com/';
  }

  const generateOptionsDate = () => {
    const options = [];
    const today = new Date();
    
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    for (let i = 0; i < 5; i++) {
      const date = new Date(tomorrow);
      date.setDate(date.getDate() + i);
      // options.push(this.formatDate(date));
    }
    
    return options;
  }

  const generateOptionsTime = ()=> {
    const options = [];
    for (let hour = 10; hour <= 12; hour++) {
        if(hour == 12){
            options.push(`${hour}:00 PM`);
            options.push(`${hour}:30 PM`);
        }
        else{
            options.push(`${hour}:00 AM`);
            options.push(`${hour}:30 AM`);
        }
    }
    for (let hour = 1; hour <= 6; hour++) {
        options.push(`${hour}:00 PM`);
        if(hour != 6){
            options.push(`${hour}:30 PM`);
        }
    }
    return options;
  }

  useEffect(() => {
    setOptionsTime(generateOptionsTime());
    setOptionsDate(generateOptionsDate());
  },[]);

  return (
    
    <>
      <div className='header'>
        <div className='container' id='head-cont'>
          <div className='row'>
            <div className='col-3 logoBox'>
              <div className='logo'>
                <img src = {rupeeIcon} id="rupeeIcon"/>
                <img src = {logo} id = "logoIcon"/>
              </div>

            
            </div>

            {/* <div className="col-6 " style={{display:'flex',justifyContent:'center'}}>
              {
                window.location.pathname === '/about' ?
                <div className='headerContent routePages' style={{fontWeight:'700'}}>
                    <a href='/about' style={{textDecoration:'none'}}>About Us</a>
                </div> :
                
                <div className='headerContent routePages'>
                    <a href='/about' style={{textDecoration:'none'}}>About Us</a>
                </div>
              }
              {
                  window.location.pathname === '/product' ?
                  <div className='headerContent routePages' style={{fontWeight:'700'}}>
                      <a href='/product' style={{textDecoration:'none'}}>Our Products</a>
                  </div> :
                  <div className='headerContent routePages'>
                      <a href='/product' style={{textDecoration:'none'}}>Our Products</a>
                  </div>
              }
            </div> */}
            {/* <div className='col-9'style={{display:'flex', alignItems:'center'}}>
              <div id='go-btn' onClick={handleGoClick}>Go To Indiamart</div>
            </div> */}
            {/* <div className='col-3 logoBox'>
              <div id='guidanceButton' onClick={ () => setGuidanceBox(true)}>
              <img src={'https://loans.imimg.com/images/loans/headerimages/call_icon.png'} style={{width:'12.55px',height:'auto',marginRight:'7px',marginBottom:'1px'}}></img>
                Get Guidance
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <Modal 
        show={guidanceBox}
        // show={true}
        backdrop="static"
        keyboard={false}
        id="guidancepopup" style={{marginLeft:'-80px',marginTop:'100px'}}>
            <div className='guidanceOuter'>
                <div>
                    <img src={'https://loans.imimg.com/images/loans/headerimages/guidance_banner.png'} alt='guidance-banner' style={{maxHeight:'375px',maxWidth:'256px'}}/>
                </div>
                <div style={{minWidth:'405px',backgroundColor:'#FFF',borderRadius:'6px'}}>
                    <img src={'https://loans.imimg.com/images/loans/headerimages/cross_icon.png'} alt='cross' style={{width:'20px',height:'20px',float:'right',marginRight:'10px',marginTop:'10px',cursor:'pointer'}} onClick={()=>{setGuidanceBox(false)}}/>

                    <div className='innerBoxGuidance'>
                        <div className='callback'>Request for Call Back</div>
                        <div className='struggleBox'>Struggling with your business loan application? <br/>Get a <span style={{color:'#02A699',fontWeight:'600'}}>Free Consultation.</span></div>
                    </div>

                    <hr></hr>
                    <div style={{marginLeft:'30px'}}>
                        <div style={{fontSize: '14px',fontWeight: '400',lineHeight: '19.6px',color: '#757575'}}>Select Your Preferred Call Time</div>

                        <label className="guidanceRadio">
                            <input 
                                type="radio" 
                                id="anytime" 
                                name="call_type" 
                                value="anytime" 
                                checked={this.state.selectedOption === 'anytime'} // Check if 'anytime' is selected
                                onChange={this.handleOptionChange} 
                            /> Anytime During business hours
                        </label> <br/>
                        
                        <label className="guidanceRadio"> 
                            <input 
                                type="radio" 
                                id="specific" 
                                name="call_type" 
                                value="specific" 
                                checked={this.state.selectedOption === 'specific'} // Check if 'specific' is selected
                                onChange={this.handleOptionChange} 
                            /> Select specific date & time
                        </label>
                        
                        {
                            this.state.selectedOption == 'specific' &&
                            <div style={{margin:'20px 10px',display:'flex'}}>

                                <div className='selectTimeDate' style={{border:'1px solid',marginLeft:'20px',paddingLeft:'8px',minWidth:'120px'}} onClick={this.toggleDate}>
                                    {this.state.selectedDate}
                                    <i class="bi bi-arrow-down" style={{width:'10px',height:'auto',marginLeft:'10px',marginBottom:'2px'}}></i>
                                </div>

                                {
                                    this.state.dateOpt && 
                                    <div className='timeDrop' id='dateDrop' style={{minWidth:'120px',marginLeft:'20px'}}>
                                        <ul style={{ listStyle: 'none', padding: '10px',marginBottom:'0px',paddingTop:'5px'}}>
                                            {optionsDate.map((date, index) => (
                                                <li key={index} value={date} onClick={() => this.handleDropClickDate(date)}>
                                                    <div>{date}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                }

                                <div className='selectTimeDate' style={{width:'27%',border:'1px solid',marginLeft:'20px',paddingLeft:'8px'}} onClick={this.toggleTime}>
                                    {this.state.selectedTime}
                                    <i class="bi bi-arrow-down" style={{width:'10px',height:'auto',marginLeft:'10px',marginBottom:'2px'}}></i>
                                </div>

                                {
                                    this.state.timeOpt && 
                                    <div className='timeDrop' id='timeDrop' >
                                        <ul style={{ listStyle: 'none', padding: '10px',marginBottom:'0px',paddingTop:'5px'}}>
                                            {optionsTime.map((time, index) => (
                                                <li key={index} value={time} onClick={() => this.handleDropClick(time)}>
                                                    <div>{time}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                            </div>
                        }

                        <hr></hr>

                    </div>

                    <div style={{position:'absolute',width:'70%',display:'inline-flex',justifyContent:'space-between',alignItems:'center',bottom:'40px',marginLeft:'30px'}}>
                        <div onClick={()=>{this.setState({guidanceBox:false})}} style={{color:'#757575',fontSize:'14px',display:'inline',cursor:'pointer',fontWeight:'700'}}>Cancel</div>

                        <div className='submitBtnHeader' onClick={() => this.handleSubmitClick()}>Submit</div>
                    </div>

                </div>
            </div>
      </Modal> */}
    </>
  )
}
